import { render } from "./NarrativeReports.vue?vue&type=template&id=d6c9cc14&scoped=true"
import script from "./NarrativeReports.vue?vue&type=script&lang=js"
export * from "./NarrativeReports.vue?vue&type=script&lang=js"

import "./NarrativeReports.vue?vue&type=style&index=0&id=d6c9cc14&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6c9cc14"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSpinner,QExpansionItem,QItemSection,QItem});
